var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-winners"},[_c(_vm.gameWinnersComponentName,_vm._b({tag:"component"},'component',{ gameName: _vm.gameName },false))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa3d51d4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game-winners/game-winners.html
// module id = null
// module chunks = 